import { IconChevronRight, IconMathGreater, IconMathLower } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { NSCard } from 'bricks';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import './UsesVsSourcesCard.scss';

export interface IUsesVsSourcesCardProps {
    usesTotal: number;
    sourcesTotal: number;
}

const UsesVsSourcesCard = ({ usesTotal, sourcesTotal }: IUsesVsSourcesCardProps) => {
    const getComparisonIcon = () => {
        if (usesTotal > sourcesTotal) {
            return IconMathGreater;
        }
        if (usesTotal < sourcesTotal) {
            return IconMathLower;
        }
        return IconChevronRight;
    };

    return (
        <NSCard className="UsesVsSourcesCard my-0 shadow-none text-dark">
            <div className="d-flex align-items-center px-2 font-12 my-1">
                <div>
                    <div className="font-weight-bold">Uses</div>
                    <div className="">{numeralFormatterCurrency(usesTotal)}</div>
                </div>
                <NSIcon
                    className="icon mx-4"
                    icon={getComparisonIcon()}
                    size="sm"
                />
                <div>
                    <div className="font-weight-bold">Sources</div>
                    <div>{numeralFormatterCurrency(sourcesTotal)}</div>
                </div>
            </div>
        </NSCard>
    );
};

export default UsesVsSourcesCard;
